export const PAGINATION_DEFAULTS = {
  DEFAULT_PAGE_SIZE: 5,
  DEFAULT_PAGE: 1,
  MAX_PAGE_SIZE: 100,
  MIN_PAGE_SIZE: 1,
} as const;

export const VALIDATION_LIMITS = {
  MAX_LENGTH: 255,
  MIN_PASSWORD_LENGTH: 8,
  MAX_PASSWORD_LENGTH: 128,
  NAME_MIN_LENGTH: 2,
  NAME_MAX_LENGTH: 50,
  WORKSPACE_NAME_MIN: 3,
  WORKSPACE_NAME_MAX: 55,
  REQUEST_LIMIT_DEFAULT: 50,
  REQUEST_LIMIT_MAX: 100,
} as const;
